import React, { useMemo } from 'react';
import { useTheme } from '@websky/core/src/theme';
import BaggageComponent from '@websky/core/src/Baggage/Baggage/components/Baggage';
import Tooltip from '@websky/core/src/BaseComponents/Tooltip';
import { useIsMobile } from '@websky/core/src/utils';
import { useToggleable } from '@websky/core/src/hooks';
import Dropdown from '@websky/core/src/Dropdown';
const Baggage = props => {
    const { Baggage: css } = useTheme('Baggage');
    const { isOpen, open, close } = useToggleable(false);
    const isMobile = useIsMobile();
    const tooltipProps = useMemo(() => {
        if (isMobile) {
            return {
                open: isOpen,
                disableFocusListener: true,
                disableHoverListener: true,
                disableTouchListener: true
            };
        }
        return {};
    }, [isMobile, isOpen]);
    return (React.createElement(Dropdown, { key: isMobile, isOpen: true, onClose: close },
        React.createElement(Tooltip, Object.assign({ title: React.createElement("div", { className: css.size }, props.baggage.size) }, tooltipProps),
            React.createElement("div", { onClick: isMobile ? open : null },
                React.createElement(BaggageComponent, Object.assign({}, props))))));
};
export default Baggage;
